import React, {FunctionComponent} from "react";
import {Brand, Organization, Service} from "@App/types";
import {useTranslation} from "react-i18next";
import {OrganizationIsAyvens, OrganizationIsLeaseplan} from "@App/utils/conditionals/organization";
import {
    OrganizationHasSelectableBevSupport,
    ServiceShouldDisplayBevOnCurrentList
} from "@App/utils/conditionals/combinations";
import {ServiceIsGlass} from "@App/utils/conditionals/services";

type FilterOverviewProps = {
    organization: Organization
    service: Service
    brand?: Brand
    bevSupport?: boolean
    commercialVehicleSupport?: boolean
};

export const FilterOverview: FunctionComponent<FilterOverviewProps> = (props: FilterOverviewProps) => {
    const {t} = useTranslation() // i18next

    return (
        <div className="relative bg-white hidden md:block border border-neutral-500 py-2 pl-8 pr-2 rounded">
            <span className={'absolute left-0 top-0 h-full w-4 pl-1 grid content-center border-r border-neutral-500'}
                  dangerouslySetInnerHTML={{__html: '<'}}/>
            <p>
                <span className={'font-bold'}>{t('filters.service')}</span>
                <span>{props.service.pivot.display_name ? props.service.pivot.display_name : props.service.name}</span>
            </p>
            {props.brand && (
                <p>
                    <span className={'font-bold'}>{t('filters.brand')}</span><span>{props.brand?.name}</span>
                </p>
            )}
            {(OrganizationHasSelectableBevSupport(props.organization) && ServiceShouldDisplayBevOnCurrentList(props.service, props.organization) || OrganizationIsAyvens(props.organization)) && (
                <p>
                    <span className={'font-bold'}>{t('filters.engineType')}</span><span
                    dangerouslySetInnerHTML={{__html: props.bevSupport ? t('Elektro-/Hybridmotor') : t('Verbrennungsmotor')}}/>
                </p>
            )}
            {OrganizationIsLeaseplan(props.organization) && !ServiceIsGlass(props.service) && (
                <p>
                    <span className={'font-bold'}>{t('filters.vehicleType')}</span><span
                    dangerouslySetInnerHTML={{__html: props.commercialVehicleSupport ? t('Nutzfahrzeug') : t('PKW')}}/>
                </p>
            )}
            <a href={t('linkToHome')} className={'absolute w-full h-full pointer bottom-0 left-0'}/>
        </div>
    );
}


